import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Modal, Button } from "react-bootstrap";

const ViewPlanModal = ({ data, show, handleClose, onSubmit}) => {
  const { setValue } = useForm();

  useEffect(() => {
    if (data) {
      setValue("name", data?.name);
      setValue("label", data?.label);
      setValue("group", data?.group?.name);
      setValue("description", data?.description);
    }
  }, [data, setValue]);

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>View Plan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={onSubmit}>
          <div className="row g-3">
            {/* Name Field */}
            <div className="col-md-6">
              <label className="form-label">Name</label>
              <div className="form-control-plaintext">{data?.name}</div>
            </div>

            {/* Label */}
            <div className="col-md-6">
              <label className="form-label">Label</label>
              <div className="form-control-plaintext">{data?.label}</div>
            </div>

            {/* Price */}
            <div className="col-md-6">
              <label className="form-label">Price</label>
              <div className="form-control-plaintext">{data?.price}</div>
            </div>

            {/* Duration */}
            <div className="col-md-6">
              <label className="form-label">Duration</label>
              <div className="form-control-plaintext">{data?.duration}</div>
            </div>

            {/* Status */}
            <div className="col-md-6">
              <label className="form-label">Status</label>
              <div className="form-control-plaintext">{data?.status}</div>
            </div>

            {/* Level */}
            <div className="col-md-6">
              <label className="form-label">Level</label>
              <div className="form-control-plaintext">{data?.level}</div>
            </div>

            {/* Description */}
            <div className="col-12">
              <label className="form-label">Description</label>
              <div className="form-control-plaintext">{data?.description}</div>
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <Button variant="danger" size="sm" onClick={handleClose}>
              Cancel
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ViewPlanModal;
